import { Grid, Box, Paper, Typography, Divider, Button, Input, Rating, Card, TextField } from "@mui/material"
import React, { useEffect, useState } from "react"
import { formatDate } from "../../utilities/date-utility"
import Header from "../header/header"
import { useDispatch } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import { GET_ORDER_BY_ID } from "../../redux/apis"
import { handlePayment } from "../../utilities/paymentUtils"
import { postReviews } from "../../utilities/reviewUtils"
import CommonAlert from "../alert/CommonAlert"
import { FaPencilAlt } from "react-icons/fa"

const HEIGHT = window.innerHeight
const WIDTH = window.innerWidth

type Props = {
    data: any;
    showButtons: boolean
}

export const OrderDetail: React.FC<Props> = ({ data, showButtons }) => {
    const navigate = useNavigate();
    const [rating, setRating] = useState(0);
    const [reviewText, setReviewText] = useState("");
    const [reviewHeadLine, setReviewHeadLine] = useState("");
    const [selectedProductId, setSelectedProductId] = useState<any>();
    const [showSuccessMsg, setShowSuccessMsg] = useState<any>(false);
    const [showErrorMsg, setShowErrorMsg] = useState<any>(false);

    const statusColors = {
        green: ['CONFIRMED', 'DELIVERED'],
        red: ['CANCELLED', 'RETURNED', 'REFUNDED', 'FAILED'],
        orange: ['PENDING', 'PROCESSING'],
        blue: ['SHIPPED', 'OUT_FOR_DELIVERY'],
    };

    const getColor = (status: any) => {
        for (const [color, statuses] of Object.entries(statusColors)) {
            if (statuses.includes(status)) {
                return color;
            }
        }
        return 'gray';
    };

    useEffect(() => {
        if (!data) {
            navigate("/profile");
        }
    }, [])

    const handleRatingChange = (event: any, newValue: any) => {
        setRating(newValue);
    };

    const handleSaveReview = () => {
        postReviews(data.orderId, selectedProductId, reviewHeadLine, reviewText, rating).then(() => {
            setShowSuccessMsg(true);
            setTimeout(() => {
                setShowSuccessMsg(false);
                setSelectedProductId(null);
            }, 2000)
        }).catch((error: any) => {
            setShowErrorMsg(true);
            setTimeout(() => {
                setShowErrorMsg(false);
            })
        });
    }

    const handleCancel = () => {
        setSelectedProductId(null);

    }

    return <>
        <Grid item xs={12} lg={5.5} mt={4}>
            <Box mt={4}>
                <Paper elevation={3} sx={{ p: 2 }}>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Typography variant="h6">
                                Order Summary
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" align="right">
                                {formatDate(data.createdAt)}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 2 }} />
                    <Box>
                        <Grid container spacing={2}>
                            {data && data.orderItems && data.orderItems.map((orderItem: any, index: any) => (
                                <React.Fragment key={index}>
                                    <Grid container sx={{
                                        borderRadius: 2, margin: '10px',
                                        border: selectedProductId && selectedProductId == orderItem.product.productId ? '2px solid green' : '1px dotted #a19c9c', paddingBottom: '10px'
                                    }}>
                                        <Grid item xs={12} sm={10} style={{ margin: 'auto' }}>
                                            <Box display={'flex'} mt={3}>
                                                {/* <img src="https://via.placeholder.com/50" alt="Product" style={{ marginRight: 16 }} /> */}
                                                <Box style={{ paddingLeft: WIDTH * 1.5 / 100 }}>
                                                    <Typography variant="subtitle2"><strong>{orderItem.product.productName}</strong> </Typography>
                                                    <Box display={'flex'}>
                                                        {/* <Typography variant="body1">$125.00</Typography> */}
                                                        <Typography variant="body2" style={{ marginLeft: '0px', color: "#DC2626" }}>
                                                            <strong>Unit Price: ${orderItem.unitPrice}</strong>
                                                        </Typography>
                                                    </Box>
                                                    <Typography variant="body2"><strong>Qty: {orderItem.quantity}</strong></Typography>
                                                </Box>
                                            </Box>
                                            {showButtons && <Button
                                                variant="text"
                                                color="primary"
                                                size="small"
                                                style={{ marginTop: '8px', marginLeft: WIDTH * 1.3 / 100 }}
                                                onClick={() => setSelectedProductId(orderItem.product.productId)}
                                            >
                                                Write Product Review
                                            </Button>}
                                        </Grid>
                                        <Grid item xs={12} sm={2} style={{ justifyContent: 'end' }} mt={3}>
                                            <Typography variant="subtitle2" align="right" style={{ fontWeight: "bolder", marginRight: '15px' }}>${orderItem.totalPrice}</Typography>
                                        </Grid>
                                    </Grid>
                                    {selectedProductId && selectedProductId == orderItem.product.productId && <>

                                        <Divider sx={{ my: 2, bgcolor: "primary.main" }} />
                                        <Box mb={3} sx={{
                                            border: '1px dotted black',
                                            borderRadius: 3,
                                            width: '80%', margin: 'auto', marginBottom: '10px', padding: '20px'
                                        }} >
                                            <Grid item xs={12} sm={12} md={12}>
                                                {showSuccessMsg && (<CommonAlert message="Review saved successfully." severity="success" variant="standard" onClose={() => { setShowSuccessMsg(false) }} />)}
                                                {showErrorMsg && (<CommonAlert message="Error saving. Try again!" severity="error" variant="standard" onClose={() => { setShowErrorMsg(false) }} />)}
                                                <Box style={{ justifyContent: "flex-start" }}>
                                                    <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                                        Do you own or have used the product?
                                                    </Typography>
                                                    <TextField
                                                        label="Review HeadLine"
                                                        variant="standard" // Options: 'outlined', 'filled', 'standard'
                                                        fullWidth
                                                        placeholder="Describe your Review Headline"
                                                        sx={{ marginTop: '8px' }}
                                                        onChange={(event: any) => {
                                                            setReviewHeadLine(event.target.value);
                                                        }}
                                                    />
                                                    <TextField
                                                        label="Review Text"
                                                        variant="standard" // Options: 'outlined', 'filled', 'standard'
                                                        fullWidth
                                                        sx={{ marginTop: '8px' }}
                                                        placeholder="Tell your experience about this product"
                                                        onChange={(event: any) => {
                                                            setReviewText(event.target.value);
                                                        }}
                                                    />
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        style={{ marginTop: "15px", marginLeft: "0px" }}
                                                    >
                                                        <Rating
                                                            name="rating"
                                                            value={rating}
                                                            precision={1}
                                                            onChange={handleRatingChange}
                                                        />
                                                    </Box>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        style={{
                                                            marginTop: "15px",
                                                            marginLeft: "0px"
                                                        }}
                                                        disabled={!(reviewText && reviewText.trim() != "" && rating != 0)}
                                                        onClick={handleSaveReview}
                                                    >
                                                        SAVE
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="warning"
                                                        size="small"
                                                        style={{
                                                            marginTop: "14px",
                                                            marginLeft: "15px"
                                                        }}
                                                        onClick={handleCancel}
                                                    >
                                                        CANCEL
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Box>

                                    </>}
                                </React.Fragment>
                            ))}
                        </Grid>
                        <Divider sx={{ my: 2 }} />
                        <Grid container>
                            <Grid item xs={12} md={10}>
                                <Typography variant="subtitle1" style={{ fontWeight: "700" }}>Sub Total</Typography>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Typography variant="subtitle2" align="right" >${data.totalAmount}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={10}>
                                <Typography variant="subtitle1" style={{ fontWeight: "700", marginTop: HEIGHT * 1 / 100 }}>Shipping</Typography>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Typography variant="subtitle2" align="right">$0.00</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={10}>
                                <Typography variant="subtitle1" style={{ fontWeight: "700", marginTop: HEIGHT * 1 / 100 }}>Tax</Typography>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Typography variant="subtitle2" align="right">$0.00</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 2 }} />
                        <Grid container>
                            <Grid item xs={12} md={10}>
                                <Typography variant="subtitle1" style={{ fontWeight: "700" }}>Order Total</Typography>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Typography variant="subtitle2" align="right" style={{ fontWeight: "700" }}>${data.totalAmount}</Typography>
                            </Grid>
                        </Grid>
                    </Box >
                </Paper >
            </Box >
        </Grid >
    </>
}